var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSustainability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 49 48.8",
    style: {
      enableBackground: "new 0 0 49 48.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:2;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_527"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,0h37c3.3,0,6,2.7,6,6v37c0,3.3-2.7,6-6,6H6c-3.3,0-6-2.7-6-6V6C0,2.7,2.7,0,6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,1h37c2.8,0,5,2.2,5,5v37c0,2.8-2.2,5-5,5H6c-2.8,0-5-2.2-5-5V6C1,3.2,3.2,1,6,1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5355",
    transform: "translate(14.278 9.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14847",
    className: "st2",
    d: "M2.8,16.6c3.8,3.8,9.9,3.8,13.7,0c0,0,0,0,0,0c3.8-3.8,3.8-10,0-13.8C12.8-0.9,6.7-1,2.9,2.8 c0,0,0,0,0,0C-0.9,6.7-0.9,12.8,2.8,16.6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5356",
    transform: "translate(6.477 8.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14848",
    className: "st2",
    d: "M5.3,0.7c0.1-0.1,0.4-0.4,0.4-0.4c-6.2,6.4-6.2,16.6,0,23c6.5,6.4,16.9,6.2,23.3-0.3 c0,0,0,0,0,0c6.4-6.2,6.7-16.4,0.7-23c0-0.1,0.3,0.2,0.4,0.4c6.7,7,6.6,18.1-0.3,24.8C23,32.1,11.9,32.3,5,25.6c0,0,0,0,0,0 C-1.8,18.6-1.6,7.5,5.3,0.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainability);
export default __webpack_public_path__ + "static/media/sustainability.fee8c63e.svg";
export { ForwardRef as ReactComponent };